module.exports = __webpack_public_path__ + "static/media/number_two_icon_new.537ff1cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/number_two_icon_new.svg
// module id = 249
// module chunks = 0